import { useEffect, useRef, useCallback, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

const useSSE = (gameId, handlers = {}) => {
  const sourceRef = useRef(null);
  const handlersRef = useRef(handlers);
  const [isConnected, setIsConnected] = useState(false);
  handlersRef.current = handlers;

  const connect = useCallback(() => {
    if (!gameId) return;
    const token = localStorage.getItem('jwtToken');
    if (!token) return;

    if (sourceRef.current) {
      sourceRef.current.close();
    }

    const source = new EventSource(
      `${API_URL}/api/multi/events/${gameId}?token=${token}`
    );

    source.onopen = () => {
      setIsConnected(true);
    };

    // Handler générique par type d'événement
    const eventTypes = [
      'player_joined', 'player_left', 'player_ready', 'country_selected',
      'game_starting', 'game_started', 'turn_submitted', 'turn_resolving',
      'turn_resolved', 'player_eliminated', 'player_disconnected',
      'player_reconnected', 'game_over', 'timer_warning', 'timer_expired',
      'vote_end_initiated', 'vote_end_updated', 'vote_end_cancelled',
      'error',
    ];

    eventTypes.forEach((eventType) => {
      source.addEventListener(eventType, (e) => {
        try {
          const data = JSON.parse(e.data);
          if (handlersRef.current[eventType]) {
            handlersRef.current[eventType](data);
          }
        } catch (err) {
          console.error(`SSE parse error for ${eventType}:`, err);
        }
      });
    });

    source.onerror = () => {
      setIsConnected(false);
      // EventSource se reconnecte automatiquement
      console.warn('SSE connection error, will retry...');
    };

    sourceRef.current = source;
  }, [gameId]);

  useEffect(() => {
    connect();
    return () => {
      if (sourceRef.current) {
        sourceRef.current.close();
        sourceRef.current = null;
      }
      setIsConnected(false);
    };
  }, [connect]);

  const disconnect = useCallback(() => {
    if (sourceRef.current) {
      sourceRef.current.close();
      sourceRef.current = null;
    }
    setIsConnected(false);
  }, []);

  return { reconnect: connect, disconnect, isConnected };
};

export default useSSE;
